// src/components/ResendVerification.js
// "Resend link" button for signed-out users whose email isn't verified yet.
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { authAPI } from '../utils/api';

export default function ResendVerification({ email, style }) {
  const [state, setState] = useState('idle'); // idle | sending | sent

  const resend = async () => {
    setState('sending');
    try {
      await authAPI.resendVerification(email);
      setState('sent');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Could not send the email');
      setState('idle');
    }
  };

  return (
    <button type="button" className="btn btn-outline" style={style} disabled={state !== 'idle' || !email} onClick={resend}>
      {state === 'sent' ? 'Link sent — check your inbox' : state === 'sending' ? 'Sending…' : 'Resend verification link'}
    </button>
  );
}
